import React, { useContext } from 'react'
import { Row, Col, Select } from 'antd'
import { AppContext } from '../../util/context';

const {Option} = Select;
export const ActionLogList = ({
    selectedAction, 
    isRep, 
    assignedView, 
    viewOnly, 
    handleActionSelection, 
    data, 
    StyledDiv,
    actionID,
    setLogValidationErrors,
}) => {
    const {
        userData
    } = useContext(AppContext);
    
    return (
        <>
            <Col
                xl={{span: 8}}
                lg={{span: 8}}
                md={{span: 0}}
                sm={{span: 0}}
                xs={{span: 0}}
                className="actionListContainer"
            >
                <Row
                    style={{
                        height: "10%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <StyledDiv
                        style={{
                            fontSize: "16px",
                            fontWeight: "600",
                        }}
                    >Actions</StyledDiv>
                </Row>

                <Row
                    style={{
                        height: "90%",
                        overflowY: "auto",
                        overflowX: "hidden",
                        padding: "10px"
                    }}
                >
                    <Col
                        span={24}
                    >
                        {data.actions.length > 0 && data.actions.map((action, index) => {
                            return (
                                <React.Fragment key={index}>
                                    {(( isRep || viewOnly ) || (assignedView && action.assignedTo === userData.given_name + " " + userData.family_name)) && <Row
                                        onClick={() => {
                                            handleActionSelection(index);
                                            setLogValidationErrors({
                                                dueDate: "", 
                                                assignedTo: "",
                                                comments: ""
                                            })
                                        }}
                                        className={selectedAction === index ? "alContainerSelected" : "alContainer"}
                                    >
                                        <Col
                                            span={24}
                                        >
                                            <StyledDiv
                                                className={selectedAction === index ? "alSelectedText" : "alSelectionText"}
                                            >{action.action}</StyledDiv>
                                        </Col>
                                        
                                    </Row>}
                                </React.Fragment>
                            )
                        })}
                    </Col>
                </Row>
            </Col>

            <Col
                xl={{span: 0}}
                lg={{span: 0}}
                md={{span: 24}}
                sm={{span: 24}}
                xs={{span: 24}}
                className="actionListContainerMobile"
            >
                <Row
                    style={{
                        height: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "10px"
                    }}
                >
                    <StyledDiv
                        style={{
                            fontSize: "16px",
                            fontWeight: "600",
                        }}
                    >Actions</StyledDiv>
                </Row>

                <Row
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingRight: "20px",
                        paddingLeft: "20px",
                        paddingBottom: "20px"
                    }}
                >
                   <Select placeholder="Select Action" style={{width: "100%", marginTop: "8px", height: "40px"}}
                        value={data.actions.length > 0 ? data.actions[selectedAction].action : null}
                        onChange={(value) => {
                            handleActionSelection(value);
                            setLogValidationErrors({
                                dueDate: "", 
                                assignedTo: "",
                                comments: ""
                            })
                        }}
                        className="optionInputText"
                    >
                        {data.actions.length > 0 && data.actions.map((action, index) => (
                            ((isRep || viewOnly) || (assignedView && action.assignedTo === userData.given_name + " " + userData.family_name)) && 
                            <Option key={action.id} value={index} >{action.action}</Option>
                        ))}
                    </Select>
                </Row>
            </Col>
        </>
    )
}
